import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { gameWasBlockedFromStarting } from "./startupCheck";

// bugreport.js runs before this one and checks that webgl works. If it doesn't,
// it has already put an explanation on screen so don't render over it.
if (!gameWasBlockedFromStarting()) {
	ReactDOM.render(
		<App />,
		document.getElementById("root")
	);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
